//#region src/wayfinder_hotspot_type.ts
let WayfinderHotspotType = /* @__PURE__ */ function(WayfinderHotspotType) {
	WayfinderHotspotType["Interactive"] = "interactive";
	WayfinderHotspotType["NonInteractive"] = "non-interactive";
	return WayfinderHotspotType;
}({});
//#endregion
export { WayfinderHotspotType };

//# sourceMappingURL=wayfinder_hotspot_type.js.map